import {EnvironmentProviders, Provider} from '@angular/core';
import {createFeature, FeatureConfig, provideState} from '@ngrx/store';
import {applicationFeatureName, applicationReducer, ApplicationState} from './store/application.reducers';
import {provideEffects} from '@ngrx/effects';
import {ApplicationEffects} from './store/application.effects';
import {ApplicationFacade} from './store/application.facade';
import {ApplicationRepository} from './store/application.repository';
import {ApplicationRestService} from './api/application-rest.service';

export function provideApplication(): (EnvironmentProviders | Provider)[] {
    return [
        provideState(createFeature({
            name: applicationFeatureName,
            reducer: applicationReducer
        } as FeatureConfig<string, ApplicationState>)),
        provideEffects([ApplicationEffects]),
        ApplicationFacade, ApplicationRepository, ApplicationRestService
    ];

}

